import { render, staticRenderFns } from "./tableCadorClients.vue?vue&type=template&id=b669b28a&scoped=true"
import script from "./tableCadorClients.vue?vue&type=script&lang=js"
export * from "./tableCadorClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b669b28a",
  null
  
)

export default component.exports